<template>
  <div v-if="ready && !$route.meta.sessionPage" class="nav-container" :class="getNavClasses">
    <div class="flex-row left">
      <CofocusLogo />
      <WorkspacesLink v-if="showWorkspacesLink" />
      <CommunityLink v-if="showCommunityLink && !$isMobile" :clean="clean" />
      <!-- <a href="/statistics" class="nav-link">Statistics</a> -->
    </div>
    <div class="right">
      <div v-if="$route.meta.sessionPage">
        <!-- atm not actually rendered -->
        <TasksButton />
      </div>
      <div v-else class="flex-row">
        <!-- <div class="review-guidelines" @click="openGuidelines" v-show="!clean">ℹ️ Review session guidelines</div> -->
        <!-- <span class="nav__separator" v-show="!clean">|</span> -->
        <!-- <a v-if="!isSupporter && this.$windowWidth > 1280 && !clean" class="buycoffee" target="_blank" href="https://www.buymeacoffee.com/cofocus"> <span class="mr-unicorn">🦄</span> Go ad-free for $3/month. </a> -->
        <div
          class="nav-container--area nav-container--streaks"
          :class="$isMobile ? 'nav--streak--mobile' : ''"
          v-if="(userstats && userstats.timezone) || loadingStreaksText"
        >
          <StreakDropdown v-if="userstats.timezone" />

          <!-- This is when user's timezone is first captured or their timezone changes 
          & their streaks calculated in their local timezone. -->
          <div v-else-if="!userstats.timezone" class="nav-container--init-streaks">{{ loadingStreaksText }}</div>
        </div>
        <div class="nav-container--area--mobile" v-if="$isMobile">
          <UserNavButton />
        </div>
        <div class="nav-container--area" v-else>
          <MessengerNotificationsButton />
          <ConnectionNotificationsButton />
          <TasksButton />
          <UserNavButton />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import CofocusLogo from "./NavComponents/CofocusLogo";
import CommunityLink from "./NavComponents/CommunityLink";
import WorkspacesLink from "./NavComponents/WorkspacesLink.vue";
import UserNavButton from "./Dropdowns/UserNavButton";
import MessengerNotificationsButton from "./Dropdowns/MessengerNotificationsButton";
import ConnectionNotificationsButton from "./Dropdowns/ConnectionNotificationsButton";
import TasksButton from "./Dropdowns/TasksButton.vue";
import StreakDropdown from "./Dropdowns/StreakDropdown.vue";

export default {
  name: "Nav",
  components: {
    CofocusLogo,
    CommunityLink,
    WorkspacesLink,
    UserNavButton,
    MessengerNotificationsButton,
    ConnectionNotificationsButton,
    TasksButton,
    StreakDropdown,
  },
  props: {
    clean: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loadingStreaksText: "",
      loadingStreaks: 0,
      timeout: null,
    };
  },
  computed: {
    ...mapState({
      ready: (state) => state.auth.ready,
      isAuthenticated: (state) => state.auth.authenticationStatus,
      user: (state) => state.auth.user,
      userstats: (state) => state.userstats,
    }),
    showWorkspacesLink() {
      return false;
      // return this.isAuthenticated;
    },
    showCommunityLink() {
      return this.isAuthenticated;
    },
    getNavClasses() {
      let classes = "";
      if (this.$route.meta.sessionPage) {
        classes = "session-nav";
      }
      /* if (this.$windowWidth < 909) {
        classes = classes + " " + "flex-column";
      } else {
        classes = classes + " " + "flex-row";
      } */
      classes = classes + " " + "flex-row";

      if (this.clean) {
        classes = classes + " " + "clean-nav";
      }
      if (this.$route.meta.newLandingPage) {
        classes = classes + " " + "new-landing-nav-container";
      }
      return classes;
    },
  },
  methods: {
    openGuidelines() {
      this.$store.dispatch("modals/setModalState", {
        modal: "miniGuidelines",
        newState: true,
      });
    },
    timezoneInitializing() {
      console.log("INITIALIZING");
      if (this.loadingStreaks === 0 && !this.userstats.timezone) {
        this.loadingStreaksText = "Initializing streaks in your timezone.";
        this.loadingStreaks++;
        this.timeout = setTimeout(this.timezoneInitializing, 500);
      } else if (this.loadingStreaks === 1 && !this.userstats.timezone) {
        this.loadingStreaksText = "Initializing streaks in your timezone..";
        this.loadingStreaks++;
        this.timeout = setTimeout(this.timezoneInitializing, 500);
      } else if (this.loadingStreaks === 2 && !this.userstats.timezone) {
        this.loadingStreaksText = "Initializing streaks in your timezone...";
        this.loadingStreaks = 0;
        this.timeout = setTimeout(this.timezoneInitializing, 500);
      } else {
        this.loadingStreaks = 0;
        this.timeout = null;
        this.loadingStreaksText = "";
      }
    },
  },
  watch: {
    /* Don't put in mounted, as otherwise text briefly shows it */
    userstats: {
      handler() {
        if (!this.userstats || !this.userstats.timezone) {
          this.timezoneInitializing();
        }
      },
      deep: true,
    },
  },
};
</script>
<style>
.nav-container {
  /* variables from AppPageContainer */
  height: var(--nav-height);
  padding: 2px 10px;
  padding: 2px 6px;
  padding-left: 0px;
  border-bottom: 1px solid #eaeaea;
  /* height: var(--nav-height);
  padding-top: var(--nav-padding-top);
  padding-bottom: var(--nav-padding-bottom); */
  /* border-bottom-width: var(--nav-border-bottom);
  border-top-width: var(--nav-border-top); */
  /* border-right-width: 1px;
  border-left-width: 1px; */
  box-sizing: border-box;
  background-color: #ffffffa6;
  box-shadow: 0px 1px 3px 0 #c5c5c557;
  border-radius: 360px;
  margin: 0;
  display: block;
  min-height: 45px;
  box-shadow: none;
  background-color: transparent;
  border: none;
}
.nav-container > div {
  max-height: var(--nav-height);
}
.session-nav {
  border: 2px solid blue;
}
.left {
  float: left;
}
.right {
  float: right;
}
.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  /* wrapping behaviour ruins for some reason  */
  /* flex-wrap: wrap; */
  justify-content: space-between;
}
.nav-button {
  padding: 7px 14px;
  border-radius: 3px;
  cursor: pointer;
  color: #abadb9;
  font-weight: 600;
}
.buycoffee {
  border-radius: 360px;
  background-color: white;
  padding: 8px 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  margin: 0px auto;
  margin-right: 16px;
  font-size: 15px;
  box-sizing: border-box;
}
.buycoffee:hover {
  background-color: #f3f301;
}
.review-guidelines {
  margin: 0px auto;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  font-size: 15px;
  border-radius: 360px;
  background-color: #ffffff;
  font-weight: 600 !important;
  cursor: pointer;
}
.review-guidelines:hover {
  background-color: #f3f3f3;
}
.mr-unicorn {
  margin-right: 4px;
}
.nav__separator {
  color: #cbcbcb;
  margin: 0px 5px;
}
.clean-nav {
  border: none !important;
  box-shadow: none !important;
  background-color: transparent !important;
  padding: 0 !important;
}
.nav-container--area {
  padding: 4px 8px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  margin-left: 8px;
  border-radius: 360px;
  /* border: 1px solid rgba(255, 255, 255, 0.1); */
  /* -webkit-backdrop-filter: blur(5px); */
  /* backdrop-filter: blur(3px); */
  box-shadow: 0px 1px 4px 0 #afafaf66;
  background-color: #ffffff8a !important;
  min-height: 42px;
  box-sizing: border-box;
  align-items: center;
}
.nav-container--streaks:hover .streaks--overview {
  display: block;
}
.nav-container--init-streaks {
  font-size: 13px;
  font-weight: 600;
  padding: 0px 6px;
  width: 220px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.nav--streak--mobile {
  padding: 4px 4px;
  min-height: 35px;
}

.nav-link {
  padding: 12px 14px;
  cursor: pointer;
  display: block;
  font-weight: 600;
  font-size: 16px;
  font-stretch: 1.2;
  color: #222;
}

.nav-link {
  margin-left: 10px;
  margin-left: 30px; /* Until Workspaces link although will be sidebar ribbon */
}
.nav-container--area--mobile {
  padding: 5px;
}
.new-landing-nav-container {
  height: 60px;
}
</style>
